export interface SuggestionChipsProps {
  message?: string
  suggestions: string[]
  onSuggestionClick: (suggestion: string) => void
}

export function SuggestionChips({ message, suggestions, onSuggestionClick }: SuggestionChipsProps) {
  return (
    <div className="space-y-2">
      {message && <p className="text-sm text-subtle">{message}</p>}
      <div className="flex flex-wrap gap-2">
        {suggestions.map((s) => (
          <button
            key={s}
            className="rounded-full border border-line px-3 py-1 text-sm hover:bg-surface-hover"
            onClick={() => onSuggestionClick(s)}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  )
}